module.exports = __webpack_public_path__ + "img/asia04.44b09aa7.png";